import { IUserSessionData } from './../../store/models/user.model';
import { EFilterType, ITableFilter } from './../../store/models/table.model';
import { Button } from './../../store/models/button.model';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ITableColumn, ITableDataSource,ITableFIlterGroup } from 'app/store/models/table.model';
import { IFollowUp } from 'app/store/models/follow_up.model';
import { ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { Router } from '@angular/router';
import { LeftMenuService } from 'app/store/services/left-menu.service';
import { SessionService } from 'app/store/services/session.service';
import { ApiDataSource } from 'app/datasources/api.datasrouce';
import { takeUntil } from 'rxjs/operators';
import { UserType } from 'app/store/models/user.model';
import { HttpClient } from '@angular/common/http';
import { IMeetingItem } from 'app/store/models/meeting.model';
import { environment } from '../../../environments/environment';

enum EMeetingStatus {
  ALL = 'all',
  WON = 'won',
  LOST = 'lost',
  ACTIVE = 'active',
}

@Component({
  selector: 'app-deleted-listing',
  templateUrl: './deleted-listing.component.html',
  styleUrls: ['./deleted-listing.component.scss'],
})
export class DeletedListingComponent implements OnInit, OnDestroy {
  tableDataSourceParams = {
    page: 1,
    pageSize: 10,
    sortAttr: 'action_data1',
    sortDir: 'desc',
    filters: {},
  };
  tableFilterGroups: ITableFIlterGroup[] = [
        {
          filters: [
            {
              type: EFilterType.SEARCH,
              label: 'Search',
              items: [
                {
                  id: 'search',
                  label: 'Search...',
                },
              ],
            },
          ]
        }
  ];
  tableColumns: ITableColumn<IMeetingItem>[];
  dataSource: ApiDataSource<IMeetingItem>;
  exportButtonProperties: Button = {
    onClick: () => {},
    size: ButtonSize.SMALL,
    text: 'Export',
    color: ButtonColor.ORANGE,
  };
  tableReady: boolean;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private filterState: EMeetingStatus = EMeetingStatus.ALL;
  tableFilters: ITableFilter[] = [
    {
      type: EFilterType.SELECT,
      label: 'View',
      id: 'meeting',
      items: [
        {
          id: 'meeting',
          label: 'Active',
          value: EMeetingStatus.ACTIVE,
        },
        {
          id: 'meeting',
          label: 'Won',
          value: EMeetingStatus.WON,
        },
        {
          id: 'meeting',
          label: 'Lost',
          value: EMeetingStatus.LOST,
        },
        {
          id: 'meeting',
          label: 'All',
          value: EMeetingStatus.ALL,
        },
      ],
      onFilterChange: value => {
        this.filterState = value;
        this.tableColumns = this.getTableColumns();
      },
    },
  ];
  private sessionData: IUserSessionData;

  constructor(
    private http: HttpClient,
    private router: Router,
    private leftMenu: LeftMenuService,
    private sessionService: SessionService,
  ) {
    this.dataSource = new ApiDataSource<IMeetingItem>(
      this.http,
      environment.apiUrl + '/v1/messages/deleted',
    );
    this.leftMenu.expand('inbox');
  }

  rowClass = () => ['route_message'];

  getTableColumns(): ITableColumn<IMeetingItem>[] {
    const sessionData = this.sessionData;
    let columns: ITableColumn<IMeetingItem>[] = [
      {
        id: 'contact_firstname',
        title: 'Contact',
        sortable: true,
        renderer: row => {
          return `${row.contact_firstname ? row.contact_firstname : ''} ${
            row.contact_lastname ? row.contact_lastname : ''
          }`;
        },
        route: row => this.onColumnClick(row),
      },
      {
        id: 'campaign_name',
        title: 'Campaign',
        sortable: true,
        route: row => this.onColumnClick(row),
      },
      {
        id: 'contact_company',
        title: 'Company',
        sortable: true,
        route: row => this.onColumnClick(row),
      },
    ];

    if (this.filterState) {
      switch (this.filterState) {
        case EMeetingStatus.ALL:
        case EMeetingStatus.ACTIVE:
          columns = [
            ...columns,
            {
              id: 'meeting_date',
              title: 'Meeting Date',
              sortable: true,
              route: row => this.onColumnClick(row),
            },
            {
              id: 'pipeline_state',
              title: 'Pipeline State',
              sortable: true,
              route: row => this.onColumnClick(row),
            },
          ];
          break;
        case EMeetingStatus.WON:
          columns = [
            ...columns,
            {
              id: 'won_lost_date',
              title: 'Won Date',
              sortable: true,
              route: row => this.onColumnClick(row),
            },
            {
              id: 'contract_value',
              title: 'Contract Value',
              sortable: true,
              route: row => this.onColumnClick(row),
            },
          ];
          break;
        case EMeetingStatus.LOST:
          columns = [
            ...columns,
            {
              id: 'won_lost_date',
              title: 'Lost Date',
              sortable: true,
              route: row => this.onColumnClick(row),
            },
            {
              id: 'lost_reason_code',
              title: 'Lost Reason Code',
              sortable: true,
              route: row => this.onColumnClick(row),
            },
          ];
          break;
      }
    }

    if (
      sessionData.user_type === UserType.MASTER ||
      sessionData.user_type === UserType.PARTNER
    ) {
      columns.push({
        id: 'account_firstname',
        title:
          sessionData.user_type === UserType.MASTER
            ? 'Account'
            : 'Representative',
        sortable: true,
        renderer: row => {
          return `${row.account_firstname} ${row.account_lastname}`;
        },
        route: row => this.onColumnClick(row),
      });
    }

    return columns;
  }

  ngOnInit() {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(sessionData => {
        this.sessionData = sessionData;
        this.tableColumns = this.getTableColumns();
        this.tableReady = true;
      });
  }

  ngOnDestroy() {
    this.destroy$.next(false);
  }

  onColumnClick(item: IMeetingItem) {
    this.router.navigate(['/messages/restore/meeting', item.meeting_id]);
  }

  onData = (items: IFollowUp[]) => {
    // this.store.dispatch(setMessagesList({list: items.map(item => item.message_id)}));
  };
}
